import { AxiosHttpClientAdapter } from '@/core/services/network/infra/adapters/axios.adapter';

/**
 * Lightweight app-wide cached store count.
 * Not a full “feature” slice—just a shared cached value with in-flight dedupe.
 */

let cached: { value: number; expiresAt: number } | null = null;
let inFlight: Promise<number | null> | null = null;

const DEFAULT_TTL_MS = 60 * 60 * 1000; // 1 hour

export async function getPhysicalStoresCount(options?: {
  force?: boolean;
  ttlMs?: number;
}): Promise<number | null> {
  const force = options?.force ?? false;
  const ttlMs = options?.ttlMs ?? DEFAULT_TTL_MS;

  const now = Date.now();
  if (!force && cached && cached.expiresAt > now) return cached.value;

  if (!force && inFlight) return inFlight;

  const httpClient = new AxiosHttpClientAdapter({
    headers: { Accept: 'application/json, text/plain' },
  });

  inFlight = (async () => {
    try {
      const payload = await httpClient.get<unknown>('/store/physical-stores-count');
      // API contract: { numberOfStores: number }
      const count =
        payload && typeof payload === 'object'
          ? (payload as Record<string, unknown>).numberOfStores
          : null;

      if (typeof count === 'number' && Number.isFinite(count)) {
        cached = { value: count, expiresAt: Date.now() + ttlMs };
        return count;
      }
      return null;
    } catch (e) {
      if (import.meta.env.DEV) {
        // Useful when the endpoint/baseURL is misconfigured
         
        console.warn('Failed to load /store/physical-stores-count', e);
      }
      return null;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}

